module.exports = __webpack_public_path__ + "img/pink-5.84dbeea9.svg";